import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adsdesk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CUR = { INR: "₹", USD: "$" };

export function fxNote(amount, currency = "INR", rate) {
  const r = Number(rate || 0);
  const n = Number(amount || 0);
  if (!r || !n) return "";
  return currency === "INR" ? `≈ ${money(n / r, "USD")}` : `≈ ${money(n * r, "INR")}`;
}

export function money(v, currency = "INR") {
  const n = Number(v || 0);
  return `${CUR[currency] || ""}${n.toLocaleString(currency === "INR" ? "en-IN" : "en-US", {
    maximumFractionDigits: 0,
  })}`;
}
